import { Modal, Button, Form } from "react-bootstrap";

const LeadStageModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Stage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Label>Stage Name *</Form.Label>
        <Form.Control />

        <div className="footer-actions">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-orange">Add</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LeadStageModal;
